import { useEffect, useMemo, useState } from "react";
import { getTimeLeftFromDateTime } from "~/utils/helper-funcations";

const useRemainingTime = (date: string, startTime: string) => {
  const [remainingTime, setRemainingTime] = useState(getTimeLeftFromDateTime(date, startTime));

  useEffect(() => {
    const interval = setInterval(() => {
      const time = getTimeLeftFromDateTime(date, startTime);
      setRemainingTime(time);

      if (time.totalSeconds <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [date, startTime]);

  const formattedHHMMSS = useMemo(() => {
    const { days, hours, minutes, seconds } = remainingTime;
    return days > 0
      ? `(${days} days) ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      : `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }, [remainingTime]);

  return {
    remainingTime,
    formattedHHMMSS,
  };
};

export default useRemainingTime;
